import { useEffect } from 'react';

import { scrollXComponente } from 'utils/scrollComponente';

import * as S from './styles';

interface IProgressiveItemsProps {
  promocaoCores: string;
  regras: Array<{
    quantidade: number;
    precoUnitario: number;
    precoUnitarioTexto: string;
  }>;
  onClick(showAfterRequest: boolean, quantity?: number): void;
}

export function ProgressiveItems({
  promocaoCores,
  regras,
  onClick,
}: IProgressiveItemsProps) {
  useEffect(() => {
    scrollXComponente('.progressive-items');
  }, []);

  return (
    <S.Container className="progressive-items">
      {regras.map((item, index) => (
        <li key={index} onClick={() => onClick(true, item.quantidade)}>
          <div className="progressive-items-top">
            <span>{item.quantidade} unid.</span>
            <strong>{item.precoUnitarioTexto} cada</strong>
          </div>
          <span
            className="progressive-items-bottom"
            style={{
              background: `${
                !!promocaoCores
                  ? `linear-gradient(to right, ${promocaoCores})`
                  : 'linear-gradient(to right, var(--green_light), var(--green_blue))'
              }`,
            }}
          >
            Comprar
          </span>
        </li>
      ))}
    </S.Container>
  );
}
